// src/hooks/useSalonLocations.js
// Shared hook — loads the locations array from salons/{salonId} once per component mount.
// Returns the array, a loading flag, and a helper to get a location by ID.

import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../utils/firebase';

export function useSalonLocations(salonId) {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading]     = useState(true);

  useEffect(() => {
    if (!salonId) { setLoading(false); return; }
    let cancelled = false;

    const load = async () => {
      try {
        const snap = await getDoc(doc(db, 'salons', salonId));
        if (!cancelled && snap.exists()) {
          setLocations(snap.data().locations || []);
        }
      } catch (err) {
        console.error('[useSalonLocations] Error:', err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, [salonId]);

  const getLocation = (locationId) => locations.find(l => l.locationId === locationId) || null;

  return { locations, loading, getLocation };
}
